import React, { useState, useEffect, useRef } from 'react';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
//import { API } from 'aws-amplify';
import '../components/estilos.css';
import { listPProduccionUltimoNumeros } from '../graphql/queries';
import {
    createPProduccionUltimoNumero, createPProduccion,
    createAutorizaciones,
    updatePlaneacion as updatePlaneacionMutation, updateRecibaSeriales, updatePlaneacionUltimoNumero, updatePProduccionUltimoNumero,
    updatePProduccion, updateAutorizaciones,
    updateRecibaSerialesMP,
    createPProduccionGeneral,
    updatePProduccionGeneral
} from '../graphql/mutations';
import Moment from 'moment';
import { useReactToPrint } from 'react-to-print';
import { GetAutorizaciones, GetClientes, GetPlaneacion, GetPlaneacionGeneral, GetPlaneacionGeneralID, GetPlaneacionID, GetPProduccion, GetPProduccionGeneral, GetPProduccionGeneralID, GetProductos, GetRecibaSeriales, GetRecibaSerialesID, GetRecibaSerialesIDMP, GetRecibaSerialesMP, GetUsuarios } from '../components/queries/Queries';
import { ObtenerSerialesPProduccion, ObtenerSerialesPlaneacion, combinarIDS } from '../components/queries/DCUbicaciones';
import { generateClient } from "aws-amplify/api";

const API = generateClient();
const initialfFormState = { formType: 'Planeación' }

export default function usePlaneacion() {
    const [clientes, setClientes] = useState([]);
    const [productosSinFiltro, setProductosSinFiltro] = useState([]);
    const [reciba, setReciba] = useState([]);
    const [recibaFiltrado, setReFiltrado] = useState([]);
    const [recibaSinFiltro, setRecibaSinFiltro] = useState([]);
    const [planeacionSinFiltro, setPlaneacionSinFiltro] = useState([]);
    const [planeaciones, setPlaneaciones] = useState([]);
    const [editar, setEditar] = useState(false);
    const [numeroP, setNumeroP] = useState(0);
    const [ultimoNumeroP, setultimoNumeroP] = useState(0);
    const [formState, updateFormState] = useState(initialfFormState);
    const [isDisabled, setisDisabled] = useState(false);
    const [buscarporFecha, setBuscarporFecha] = useState(true);
    const [estadoReciba, setEstadoReciba] = useState("todos");
    const [search, setSearch] = useState("");
    const [fechaPBusqueda, setFechaPBusqueda] = useState("");
    const [comentariosNoFIFO, setComentariosNoFIFO] = useState("");
    const [usuarioAutNoFIFO, setUsuarioAutNoFIFO] = useState("");
    const [searchBy, setSearchBy] = useState("cliente");
    const [totalRecords, setTotalRecords] = useState(0);
    const [faltanDatos, setFaltanDatos] = useState(true);
    const { formType } = formState;
    const [mensajeAlert, setMensajeAlert] = useState("No fue posible realizar la operación, error indeterminado: revise su conexión a internet, recargue la página y vuelva a intentarlo, si el error persiste, favor de comunicarse a sistemas");
    const [color, setColor] = useState("warning");
    const userName = window.$name;
    const pplaneacion = window.$Planeacion ? window.$Planeacion : false;
    const verpplaneacion = window.$verPlaneacion ? window.$verPlaneacion : false;
    const vpreciounitario = window.$VerPrecioUnitario ? window.$VerPrecioUnitario : false;
    const [aVisible, setAVisible] = useState(false);
    const [cargando, setCargando] = useState(false);
    const [cargando1, setCargando1] = useState(false);
    const [fechaPlaneacion, setFechaPlaneacion] = useState("");
    const [fechaPlaneacionM, setFechaPlaneacionM] = useState("");
    const [sumProduccion, setSumProduccion] = useState("");
    const [sumProduccionp, setSumProduccionp] = useState("");
    const [sumCiclos, setSumCiclos] = useState("");
    const [vistaNumeroParte, setVistaNumeroParte] = useState(false);
    const [sumICiclos, setSumICiclos] = useState("");
    const [sumCostoTotal, setSumCostoTotal] = useState("");
    const onDismiss = () => setAVisible(false);
    const [inputList, setInputList] = useState([]);
    const [activeTab, setActiveTab] = useState('1');
    const [paginas, setPaginas] = useState([]);
    const [usariosNC, setUsuariosNC] = useState([]);
    const [noFIFOUsuarios, setNOFIFOUsuarios] = useState([]);
    const [rPANOFIFO, setRPANOFIFO] = useState("");
    const [modal, setModal] = useState(false);
    const [precioUnitarioImp, setPrecioUnitarioIMP] = useState(false);
    const [modal2, setModal2] = useState(false);
    const [vistaUltimoAP, setVistaUltimoAP] = useState(false);
    const [planeacionSinFIFO, setPlaneacionSinFIFO] = useState(false);
    const [modificados, setModificados] = useState([]);
    const [textPQR, setPQR] = useState("Con código QR");

    Moment.locale('en');
    var now = new Date();
    var now2 = new Date();
    var cincoDias = new Date();
    //now2.setMonth(now2.getMonth() - 1);
    now2.setDate(now2.getDate() - 1);
    now.setDate(now.getDate() + 5);
    const [rfechaini, setRfechaini] = useState(Moment(now2).format("YYYY-MM-DD"));
    const [rfechafin, setRfechafin] = useState(Moment(now).format("YYYY-MM-DD"));


    const toggle1 = tab => {
        if (activeTab !== tab) setActiveTab(tab);
        if (tab > 1) setAVisible(false);
    }

    const toggle = () => setModal(!modal);
    const toggle2 = () => setModal2(!modal2);

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    // current page
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPagePlaneacion, setCurrentPagePlaneacion] = useState(1);

    // total records per page to display
    const recordPerPage = 20;

    // range of pages in paginator
    const pageRange = 5;

    function handleError(err) {
        console.error(err)
    };

    function handleScan(data) {
        if (data) {
            const datosPlaneacion = recibaSinFiltro.filter(Ralmacen => Ralmacen.id === data.replaceAll('\'', '-'))
            if (datosPlaneacion.length && datosPlaneacion[0].piezasenAlmacen > 0) {
                if (datosPlaneacion[0].cantidadPlaneada >= datosPlaneacion[0].piezasenAlmacen) {
                    window.scrollTo(0, 0);
                    setMensajeAlert("No fue posible realizar la operación: Material ya planificado.");
                    setColor("warning");
                    setCargando(false);
                    setAVisible(true);
                } else {
                    setPQR("Con código QR");
                    clicPlaneacion(datosPlaneacion[0], false);
                }
            } else {
                window.scrollTo(0, 0);
                setMensajeAlert("No fue posible realizar la operación: el código QR no coincide con ningún número de serie disponible para su planeación, favor de buscar el material que corresponda y volver a intentarlo");
                setColor("warning");
                setCargando(false);
                setAVisible(true);

            }
        }
        return <p>{data}</p>
    };
    function clicConQR() {
        //setRegistroIndividual(false);
        if (textPQR === "Con código QR") {
            setPQR("Finalizar agregado");
            //setCargaCompleta(false);
            // moveralSiguiente();
        } else {
            setPQR("Con código QR");
            //fetchPlanProduccionPEyP();
        }

    };


    // handle change event
    function handlePageChange(pageNumber) {
        setAVisible(false);
        setCargando(false)
        setCurrentPage(pageNumber);
        busqueda(recibaSinFiltro, estadoReciba, searchBy, search, pageNumber, vistaUltimoAP);
    }

    // handle change event
    function handlePageChangePlaneacion(pageNumber) {
        window.scrollTo(0, 0);
        setCargando(true);
        setAVisible(false);
        setCurrentPagePlaneacion(pageNumber);
        busquedaPlaneacion(planeacionSinFiltro, pageNumber, fechaPBusqueda, vistaNumeroParte);
    }

    async function busquedaPlaneacion(planeacionsg, currentPage, fechaBusqueda, vistaNP) {
        var i = 1;
        var paginasp = [];
        var p = 0;
        var pi = 1;
        var racks = 0;
        var ciclos = 0;
        var costoTotalP = 0;
        var costoTotalD = 0;
        var costoTotalE = 0;

        //Se filtran los datos por los parámetros establecidos
        /*planeacionsg = await planeacionsg.filter(planeacion => fechaBusqueda ? planeacion.fechaDePlaneacion === fechaBusqueda :
           planeacion.fechaDePlaneacion === planeacion.fechaDePlaneacion);  */

        //Si existen planeaciones a mostrar          
        if (planeacionsg.length > 0) {
            //Se obtienen el número de páginas correspondientes
            await Promise.all(planeacionsg.map(async planeacion => {
                if (planeacion.numero !== p) {
                    paginasp.push({ pagina: pi, paginareal: planeacion.numero });
                    p = planeacion.numero;
                    pi++;
                    planeacion.paginacion = pi - 1;
                }
                return planeacion;
            }));
            //Se filtran los datos por la página solicitada
            planeacionsg = planeacionsg.filter(planeacion => planeacionsg.length === 1 ? planeacion.paginacion === planeacion.paginacion :
                planeacion.paginacion === currentPage);

            var planeacionsf = await ObtenerSerialesPProduccion(planeacionsg[0].PProduccionIDS);
            //var planeacionsf = await ObtenerSerialesPlaneacion(planeacionsg[0].PlaneacionIDS);
            if (currentPage < 1) {
                currentPage = 1;
                setCurrentPagePlaneacion(1);
            }

            if (currentPage > pi - 1) {
                currentPage = currentPage - 1;
                setCurrentPagePlaneacion(currentPage);
            }
            if (vistaNP === true) {
                var planeacionesANP = [];
                var planeacionesSOANP = planeacionsf.sort((a, b) =>
                    a.numerodeParte < b.numerodeParte ? 1 : a.numerodeParte > b.numerodeParte ? -1 : 0);

                var sumEmpaques = parseFloat(planeacionesSOANP[0].materialEnCantidad);
                var sumRacks = parseFloat(planeacionesSOANP[0].racks);
                var sumCantidad = parseInt(planeacionesSOANP[0].cantidadPiezas);
                var sumCiclos = parseFloat(planeacionesSOANP[0].ciclos);
                //var uplaneacion={};

                await Promise.all(planeacionesSOANP.map(async (planeacion, j) => {
                    if (planeacionesSOANP.length > j + 1) {
                        if (planeacion.numerodeParte === planeacionesSOANP[j + 1].numerodeParte && planeacion.cliente === planeacionesSOANP[j + 1].cliente &&
                            planeacion.descripcion === planeacionesSOANP[j + 1].descripcion && planeacion.materialEn === planeacionesSOANP[j + 1].materialEn) {
                            sumRacks = sumRacks + parseFloat(planeacionesSOANP[j + 1].racks);
                            sumCantidad = sumCantidad + parseInt(planeacionesSOANP[j + 1].cantidadPiezas);
                            sumCiclos = sumCiclos + parseFloat(planeacionesSOANP[j + 1].ciclos);
                            sumEmpaques = sumEmpaques + parseFloat(planeacionesSOANP[j + 1].materialEnCantidad);
                        } else {
                            planeacionesANP.push({
                                ...planeacion, materialEnCantidad: sumEmpaques,
                                racks: sumRacks, cantidadPiezas: sumCantidad, ciclos: sumCiclos,
                            });
                            sumRacks = parseFloat(planeacionesSOANP[j + 1].racks);
                            sumCantidad = parseInt(planeacionesSOANP[j + 1].cantidadPiezas);
                            sumCiclos = parseFloat(planeacionesSOANP[j + 1].ciclos);
                            sumEmpaques = parseFloat(planeacionesSOANP[j + 1].materialEnCantidad);
                        }
                    } else {
                        planeacionesANP.push({
                            ...planeacion, materialEnCantidad: sumEmpaques,
                            racks: sumRacks, cantidadPiezas: sumCantidad, ciclos: sumCiclos
                        });
                    }

                    return planeacion;
                }));

                planeacionsf = planeacionesANP;
            }
            setultimoNumeroP(pi - 1);
            const planeacioncp = planeacionsf.sort((a, b) =>
                a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0);
            if (planeacioncp.length)
                setFechaPlaneacionM(planeacioncp[0].fechaDePlaneacion);

            await Promise.all(planeacioncp.map(async planeacion => {
                planeacion.color = "";
                if (planeacion.atrasado === true) {
                    planeacion.color = "table-warning";
                } else if (i === 2) {
                    planeacion.color = "table-active";
                    i = 0;
                }
                i++;
                racks += parseFloat(planeacion.racks);
                ciclos += parseFloat(planeacion.ciclos);
                if (planeacion.divisa === "Dólar")
                    costoTotalD += parseFloat((planeacion.precioUnitario ? planeacion.precioUnitario : 0) * planeacion.cantidadPiezas);
                if (planeacion.divisa === "Euro")
                    costoTotalE += parseFloat((planeacion.precioUnitario ? planeacion.precioUnitario : 0) * planeacion.cantidadPiezas);
                if (planeacion.divisa === "Peso mexicano")
                    costoTotalP += parseFloat((planeacion.precioUnitario ? planeacion.precioUnitario : 0) * planeacion.cantidadPiezas);
                return planeacion;
            }));
            if (racks > 0)
                setSumProduccion(racks.toFixed(2) + " RACKS " + (racks / 19).toFixed(2) + " HORAS DE PRODUCCIÓN")
            else
                setSumProduccion("");

            if (ciclos > 0)
                setSumICiclos(ciclos + " CICLOS")
            else
                setSumICiclos("");
            const costoTotal = costoTotalD
            if (costoTotalD > 0 || costoTotalE > 0 || costoTotalP > 0)
                setSumCostoTotal("COSTO TOTAL:" + ((costoTotalD > 0 ? " $" + costoTotalD.toFixed(2) + " DÓLARES" : "") +
                    (costoTotalE > 0 ? " $" + costoTotalE.toFixed(2) + " EUROS" : "") + (costoTotalP > 0 ? " $" + costoTotalP.toFixed(2) + " PESOS MEXICANOS" : "")));
            else
                setSumCostoTotal("");

            setPlaneaciones(planeacioncp);
            setPaginas(paginasp);
        } else {
            setSumICiclos("");
            setSumProduccion("");
            setSumCostoTotal("");
            setPlaneaciones([]);
            setPaginas([]);
        }
        setCargando(false);
    }
    async function busqueda(recibasinf, estadoReciba, searchb, search, currentPage, vistaUAP) {
        var pag = 1;
        var bandera = 1;
        var num = 0;
        //Se revisa el tipo de vista que se requiere de los datos        
        var recibaFromAPI = vistaUAP === true ? recibasinf.sort((a, b) =>
            a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0) :
            recibasinf.sort((a, b) => a.createdAt > b.createdAt ? 1 : a.createdAt < b.createdAt ? -1 : 0);
        //Se agrega el número de registro y se ponen los datos en reciba sin filtro
        await Promise.all(recibaFromAPI.map(async reciba => {
            reciba.registro = num;
            num++;
            return reciba;
        }));
        // se asigna a setRecibaSinFiltro los datos sin filtrado por piezasenAlmacen
        setRecibaSinFiltro(recibaFromAPI);
        // se asigna a setReFiltrado los datos filtrados por piezasenAlmacen: {gt: 0}
        recibaFromAPI = recibaFromAPI.filter(reciba => reciba.piezasenAlmacen > 0);
        setReFiltrado(recibaFromAPI);

        //Filtrado de datos por la búsqueda y el estado de reciba
        recibaFromAPI = recibaFromAPI.filter(reciba => parseInt(parseInt(reciba.cantidadRecibida) - parseInt(reciba.cantidadPlaneada ? reciba.cantidadPlaneada : 0)) > 0).filter(reciba =>
            estadoReciba === "todos" ? reciba.status === reciba.status : reciba.status === estadoReciba).filter(reciba =>
                searchb === "numero de parte" ? reciba.numerodeParte.toLowerCase().includes(search.toLowerCase()) :
                    searchb === "cliente" ? reciba.cliente.toLowerCase().includes(search.toLowerCase()) :
                        searchb === "id de reciba" ? reciba.numero.toLowerCase().includes(search.toLowerCase()) :
                            searchb === "serial" ? reciba.serial.toLowerCase().includes(search.toLowerCase()) :
                                searchb === "serial BTI" ? reciba.serialRecibaBTI ? reciba.serialRecibaBTI.toLowerCase().includes(
                                    search.toLowerCase()) : "".includes(search.toLowerCase()) :
                                    searchb === "paking" ? reciba.packing.toLowerCase().includes(search.toLowerCase()) :
                                        searchb === 'lote' ? reciba.lote.toLowerCase().includes(search.toLowerCase()) :
                                            reciba.fechayHoraDeReciba.includes(Moment(search).format("DD/MM/YYYY")));




        await Promise.all(recibaFromAPI.map(async reciba => {
            const restFechas = (new Date()).getTime() - (new Date(reciba.fechaDeReciba)).getTime();
            reciba.FEPlanta = Math.round(restFechas / (1000 * 60 * 60 * 24));
            reciba.indexpag = pag;
            bandera++;
            if (bandera > recordPerPage) {
                bandera = 1;
                pag++;
            }

            return reciba;
        }))


        const lengthreciba = recibaFromAPI.length;
        if (lengthreciba <= 0)
            setCurrentPage(1);

        setReciba(recibaFromAPI.filter(reciba => reciba.indexpag === currentPage));
        setTotalRecords(lengthreciba);

        if (currentPage > 1 && lengthreciba > 0) {
            const prepaginas = parseInt(lengthreciba / recordPerPage);
            const paginas = prepaginas * recordPerPage < lengthreciba ? prepaginas + 1 : prepaginas;
            if (currentPage > paginas) {
                setCurrentPage(paginas);
                const recibaFromAPIp = recibaFromAPI.filter(reciba =>
                    reciba.indexpag === paginas);
                setReciba(recibaFromAPIp);
            }
        }
        setCargando1(false);
    }
    //Método useEffect
    useEffect(() => {
        fetchClientes();
        fetchPlaneaciones(rfechaini, rfechafin);
        fetchReciba();
        fetchUsuario();
        fetchProductos();
    }, []);

    //Obtiene los datos guardados de los clientes
    async function fetchClientes() {

        //Filtro por cliente activo
        let filter = {
            activo: {
                eq: true
            }
        }

        //Se obtienen los datos de los clientes
        const apiData = await GetClientes(filter);

        setClientes(apiData);
    }

    //Obtiene los datos guardados de las planeaciones
    async function fetchPlaneaciones(fechainicial, fechafinal) {
        //Filtro por planeación activa
        window.scrollTo(0, 0);
        setCargando(true);
        setInputList([]);
        let filter = {
            and: [{
                activo: {
                    eq: true
                }
            },
            {
                fechaDePlaneacion: {
                    ge: fechainicial
                }
            },
            {
                fechaDePlaneacion: {
                    le: fechafinal
                }
            }]
        }

        //Se obtienen los datos de la planeación
        const apiData = await GetPProduccionGeneral(filter);

        //Se obtienen los datos de la planeación
        //const apiData = await GetPlaneacion(filter);
        const planeacionesFromAPI = apiData.filter(planeacion => planeacion.PProduccionIDS.length > 0).sort((a, b) =>
            a.fechaDePlaneacion < b.fechaDePlaneacion ? 1 : a.fechaDePlaneacion > b.fechaDePlaneacion ? -1 : 0);
        setPlaneacionSinFiltro(planeacionesFromAPI);
        busquedaPlaneacion(planeacionesFromAPI, currentPagePlaneacion, fechaPBusqueda, vistaNumeroParte);
    }
    //Obtiene los datos guardados de los productos
    async function fetchProductos() {
        //Se obtienen los datos de productos
        const apiData = await GetProductos();
        setProductosSinFiltro(apiData);
        //return apiData;
    }
    //Obtiene los datos guardados de Reciba
    async function fetchReciba() {
        setCargando1(true);
        let filter = {
            and: [
                {
                    activo: {
                        eq: true
                    }
                },
                {
                    piezasenAlmacen: {
                        gt: 0,
                    },
                },]
        }

        //Se obtienen los datos de los seriales
        const apiData = await GetRecibaSerialesMP(filter);
        const recibaFromAPI = apiData.sort((a, b) =>
            a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0);

        busqueda(recibaFromAPI, estadoReciba, searchBy, search, currentPage, vistaUltimoAP);
        return recibaFromAPI;
    }

    //Obtiene los usuarios activos con permisos para autorizar no usar FIFO en planeación.
    async function fetchUsuario() {
        //Filtro por usuarios activos        
        let filter = {
            activo: {
                eq: true
            }
        }
        //Se obtienen los datos de los usuarios
        const apiData = await GetUsuarios(filter);
        //Se ordenan los datos por el campo orden
        const dataFromAPI = apiData.sort((a, b) =>
            a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0);
        const usuarioLG = dataFromAPI.filter(usuarios => usuarios.usuario === userName);
        setUsuariosNC(usuarioLG[0] ? usuarioLG[0].nombreCompleto : "");
        setPlaneacionSinFIFO(usuarioLG[0] ? usuarioLG[0].PlaneacionSinFIFO ? usuarioLG[0].PlaneacionSinFIFO : false : false);
        setNOFIFOUsuarios(dataFromAPI.filter(usuarios => usuarios.PlaneacionAutNoFIFO === true));
    }

    //Obtiene los datos de la última ubicación del material guardados en recibaSeriales
    function obtenerUltimaUbicaciont(ubicacion) {
        var uUbicacion = "";
        var uLocacion = "";
        var uCantidad = "";
        var uEspacio = "";
        return <>
            <Table className="bordersubtabla">
                <Thead>
                    <Tr>
                        <Th className="subtablah bordersubtabla">Ubic.</Th>
                        <Th className="subtablah bordersubtabla">Loc.</Th>
                        <Th className="subtablah bordersubtabla">Pzs.</Th>
                        <Th className="subtablah bordersubtabla">Esp.</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {ubicacion && (
                        <>
                            {ubicacion.map(x => (
                                uUbicacion = x.substr(1, x.search(',') - 1).replace('ubicacion=', ''),
                                uLocacion = x.substr(x.search('locacion=') + 8, x.length).substr(1, x.substr(x.search('locacion=') + 8, x.length).search(',') - 1).replace('locacion=', ''),
                                uCantidad = x.substr(x.search('cantidad=') + 8, x.length).substr(1, x.substr(x.search('cantidad=') + 8, x.length).search(',') - 1).replace('cantidad=', ''),
                                uEspacio = x.substr(x.search('espacio=') + 7, x.length).substr(1, x.substr(x.search('espacio=') + 7, x.length).search('}') - 1).replace('espacio=', ''),
                                <Tr>
                                    <Td className="bordersubtabla">{uUbicacion}</Td>
                                    <Td className="bordersubtabla">{uLocacion}</Td>
                                    <Td className={uLocacion ? "bordersubtabla" : "margintopmobil20px bordersubtabla"}>{uCantidad}</Td>
                                    <Td className="bordersubtabla">{uEspacio}</Td>
                                </Tr>

                            ))}
                        </>)}
                </Tbody>
            </Table>
        </>
    }

    //Obtiene los datos de la última ubicación del material guardados en recibaSeriales
    function obtenerUltimaUbicacionPlaneacion(ubicacion) {
        var locaciones = "";
        var locacion = "";
        if (ubicacion) {
            ubicacion.map(x => (
                locacion = "",
                locacion = x.substr(x.search('locacion=') + 8, x.length).substr(1, x.substr(x.search('locacion=') + 8, x.length).search(',') - 1).replace('locacion=', ''),
                locaciones = locacion === "" ? locaciones : locaciones === "" ? locacion : locaciones + ", " + locacion
            ));
        }
        return locaciones;
    }
    function leerubicacioneditar(reciba) {
        var list = [];

        list.push({
            id: "", RecibaSerialesID: reciba.recibaSerialID, ubicaciondeReciba: true, lote: reciba.lote, serial: reciba.serial,
            cantidad: reciba.piezasenAlmacen, ubicacion: reciba.ubicacion, locacion: reciba.locacion, espacioOcupado: reciba.espacioOcupado,
            comentarios: "", activo: true, orden: 0, fechaIngreso: reciba.fechaDeUbicacion, horaIngreso: reciba.horaDeUbicacion,
            horaSalida: "00:00", ultimo: true, ultimoAnterior: 0, Reg_Ins_Usuario: "", Reg_Mod_Usuario: "", nuevo_registro: true,
            locacionOriginal: reciba.locacion
        })

        return list;
    }
    function buscarpor(e) {
        setAVisible(false);
        setSearchBy(e.target.value);
        if (search && e.target.value !== "fecha")
            busqueda(recibaSinFiltro, estadoReciba, e.target.value, search, currentPage, vistaUltimoAP);
    };
    function onSearch(e) {
        setAVisible(false);
        busqueda(recibaSinFiltro, estadoReciba, searchBy, search, currentPage, vistaUltimoAP);
    };
    function onSearchFecha(e) {
        setAVisible(false);
        setSearch(e.target.value);
        busqueda(recibaSinFiltro, estadoReciba, searchBy, e.target.value, currentPage, vistaUltimoAP);
    };
    function onSearchFechaPlaneacion(e) {
        setAVisible(false);
        window.scrollTo(0, 0);
        setCargando(true);
        setFechaPBusqueda(e.target.value);
        // busquedaPlaneacion(planeacionSinFiltro, currentPagePlaneacion, e.target.value, vistaNumeroParte);
        fetchPlaneaciones(e.target.value, e.target.value);
    };
    function clicBuscarporFecha(e) {
        setAVisible(false);
        setBuscarporFecha(!buscarporFecha);
        if (!buscarporFecha === false) {
            if (fechaPBusqueda !== "") {
                setFechaPBusqueda("");
                //busquedaPlaneacion(planeacionSinFiltro, currentPagePlaneacion, "", vistaNumeroParte);
                fetchPlaneaciones(rfechaini, rfechafin);
            }
        }
    };
    async function onChangeCliente(e, i) {
        const list = [...inputList];
        const { name, value } = e.target;
        const clienteFromAPI = clientes.filter(cliente => cliente.id === e.target.value);
        await Promise.all(clienteFromAPI.map(async cliente => {
            list[i][name] = value;
            list[i].cliente = cliente.cliente;
            list[i].descripcion = '';
            list[i].productoID = '';
        }));
        //setProductos(await fetchProductos(e.target.value));       
        setInputList(list);
        //if (e.target.value) 


    };
    async function onChangeProducto(e, i) {
        const list = [...inputList];
        const { name, value } = e.target;
        const productosFromAPI = productosSinFiltro.filter(producto => producto.id === e.target.value);
        await Promise.all(productosFromAPI.map(async producto => {
            list[i][name] = value;
            list[i].numerodeParte = producto.numerodeParte;
            list[i].descripcion = producto.descripcion;
            list[i].piezasXRack = producto.piezasXRack;
            list[i].precioUnitario = producto.precioUnitario;
            list[i].divisa = producto.divisa;
            list[i].racks = (list[i].cantidadPiezas && producto.piezasXRack) ? (parseFloat(list[i].cantidadPiezas) / parseFloat(producto.piezasXRack)).toFixed(2) : "";

        }));
        setInputList(list);
    };
    function handleRemoveClick(index, list) {
        if (!editar || !list[index].id)
            list.splice(index, 1);
        else
            list[index].activo = false;

        FaltanDatosPlaneacion(list);
        SumarRacksProduccion(list);
        return list;
    };
    function handleAddClick() {
        setInputList([...inputList, {
            recibaSerialID: '', fechaDePlaneacion: fechaPlaneacion, numero: 0, clienteID: '', productoID: '', cliente: '', numerodeParte: '', descripcion: '', prioridad: '1',
            cantidadPiezas: '', materialEnCantidad: 0, racks: '', ciclos: '1', activo: true, Reg_Ins_Usuario: '', Reg_Mod_Usuario: ''
        }]);
        setFaltanDatos(true);
    };
    function cancelarplaneacion() {
        setInputList([]);
        setEditar(false);
        toggle1('1');
        setFechaPlaneacion("");
        fetchClientes();
        fetchPlaneaciones(rfechaini, rfechafin);
    };
    function SumarRacksProduccion(list) {
        var racks = 0;
        var ciclos = 0;
        list.map((planeacion, i) => {
            if (planeacion.activo) {
                if (planeacion.racks) {
                    racks += parseFloat(planeacion.racks);
                };
                if (planeacion.ciclos) {
                    ciclos += parseFloat(planeacion.ciclos);
                };
            };
        });
        setSumProduccionp(racks.toFixed(2) + " RACKS " + (racks / 19).toFixed(2) + " HORAS DE PRODUCCIÓN");
        setSumCiclos(ciclos + " CICLOS");
    };
    // handle input change
    function handleInputChange(e, index, list) {
        const { name, value } = e.target;
        const re = /^[0-9\.]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            list[index][name] = value;
        }
        if (e.target.name === "racks") {
            SumarRacksProduccion(list);
        }
        if (e.target.name === "cantidadPiezas" && list[index].piezasXRack > 0) {
            list[index].racks = value > 0 ? (parseFloat(value) / parseFloat(list[index].piezasXRack ? list[index].piezasXRack : 0)).toFixed(2) : 0;
        }
        FaltanDatosPlaneacion(list);
        return list
    };
    function clicEliminar() {
        setModal(!modal);
    };
    function clicPlaneacion(recibap, permisoPSFIFO) {
        /*const recibaAnterior = recibaFiltrado.filter(reciba => reciba.numerodeParte === recibap.numerodeParte &&
            reciba.fechaDeReciba < recibap.fechaDeReciba && reciba.cantidadPlaneada < reciba.piezasenAlmacen
            && recibap.autNoFIFO !== "Aceptada")
        setRPANOFIFO(recibap);
        if (recibaAnterior.length && permisoPSFIFO === false) {
            setModal2(!modal2)
        } else {*/
        //Si el material que se quiere agregar, ya se encuentra en la planeación, solo se suma la cantidad que corresponde
        const datoRepetido = inputList.filter(datosPlaneacion => datosPlaneacion.recibaSerialID === recibap.recibaSerialID);
        var lista = [...inputList];
        if (!datoRepetido[0]) {
            const cantidadPiezasD = recibap.piezasenAlmacen - recibap.cantidadPlaneada;
            const producto = productosSinFiltro.filter(producto => producto.id === recibap.productoID);//!recibap.piezasXRack ? GetProductosID(recibap.productoID) : {};
            const piezasRack = !producto[0].piezasXRack ? recibap.piezasXRack : producto[0].piezasXRack;
            //setModificados(producto);
            lista.push({
                fechaDePlaneacion: fechaPlaneacion, numero: 0, recibaSerialID: recibap.recibaSerialID, clienteID: recibap.clienteID,
                productoID: recibap.productoID, cliente: recibap.cliente, numerodeParte: recibap.numerodeParte,
                descripcion: recibap.descripcion, serial: recibap.serial, serialRecibaBTI: recibap.serialRecibaBTI,
                locacion: obtenerUltimaUbicacionPlaneacion(recibap.ultimaUbicacion), divisa: recibap.divisa, recibaSerialMPID: recibap.id,
                cantidadPiezas: cantidadPiezasD, materialEn: recibap.materialEn, precioUnitario: recibap.precioUnitario,
                materialEnCantidad: ((cantidadPiezasD) / (recibap.piezasenAlmacen / recibap.materialEnCantidad)), piezasXRack: piezasRack,
                prioridad: '1', racks: piezasRack ? piezasRack > 0 ? (parseFloat(cantidadPiezasD) / parseFloat(piezasRack)).toFixed(2) : '' : '', ciclos: '1', activo: true, Reg_Ins_Usuario: '', Reg_Mod_Usuario: '', cantidadOriginal: 0,
                prioridadOriginal: 0, racksOriginal: "", materialEnCantidadOriginal: "", ciclosOriginal: "",
                cantidadDisponible: cantidadPiezasD, autNoFIFO: permisoPSFIFO === true ? "Aceptada" : recibap.autNoFIFO,
                autPNoFIFOComentTIOA: permisoPSFIFO === true ? comentariosNoFIFO : recibap.autPNoFIFOComentTIOA,
                cantidadPlaneadaOriginal: !recibap.cantidadPlaneada ? 0 : recibap.cantidadPlaneada, updatedAt: recibap.rsUpdatedAt
            })
            recibaSinFiltro[recibap.registro].cantidadPlaneada = recibaSinFiltro[recibap.registro].cantidadPlaneada + recibap.piezasenAlmacen;
        } else {
            datoRepetido[0].cantidadPiezas = parseInt(datoRepetido[0].cantidadPiezas ? datoRepetido[0].cantidadPiezas : 0) + (recibap.cantidadRecibida - recibap.cantidadPlaneada);
            recibaSinFiltro[recibap.registro].cantidadPlaneada = recibaSinFiltro[recibap.registro].cantidadPlaneada + (recibap.cantidadRecibida - recibap.cantidadPlaneada);
        }
        busqueda(recibaSinFiltro, estadoReciba, searchBy, search, currentPage, vistaUltimoAP);
        setInputList(lista);
        //}
    };
    async function clicEditar() {
        setCargando(true);
        //Si existen registros        
        if (planeaciones.length) {
            //Se declara la variable tipo Array lista
            var lista = [];

            await Promise.all(planeaciones.map(async (planeacion, i) => {
                //Se obtiene la cantidad disponible tomando en cuenta los datos de la reciba sin filtros. 
                //Se obtiene el registro actualizado de los reciba seriales
                var oCantidadDisponible = planeacion.recibaSerialID ? planeacion.cantidadPiezas : 200000;
                if (planeacion.recibaSerialID) {
                    var listr = await GetRecibaSerialesID(planeacion.recibaSerialID);
                    if (listr.id) {
                        oCantidadDisponible = oCantidadDisponible === listr.cantidadRecibida ? oCantidadDisponible :
                            ((oCantidadDisponible + listr.piezasenAlmacen) - listr.cantidadPlaneada) > 0 ?
                                ((oCantidadDisponible + listr.piezasenAlmacen) - listr.cantidadPlaneada) : planeacion.cantidadPiezas;
                    }
                }
                //Se agrega 
                lista.push({
                    ...planeacion, cantidadDisponible: oCantidadDisponible,
                    cantidadOriginal: planeacion.cantidadPiezas, prioridadOriginal: planeacion.prioridad,
                    racksOriginal: planeacion.racks, materialEnCantidadOriginal: planeacion.materialEnCantidad, ciclosOriginal: planeacion.ciclos, updatedAt: planeacion.updatedAt
                })

            }));
            //Se obtiene el número de la planeación
            setNumeroP(planeaciones[0].numero);
            setInputList(lista);
            setFechaPlaneacion(planeaciones[0].fechaDePlaneacion);
            setEditar(true);
            setFaltanDatos(false);
            SumarRacksProduccion(lista);
            //setSumProduccion()
            toggle1("4");
        }
        setCargando(false);
    };
    function clicNuevaPlaneacion() {
        setFechaPlaneacion("");
        setInputList([]);
        setEditar(false);
        toggle1('4');
    };
    async function aceptarEliminar() {
        setModal(!modal);
        setAVisible(false);
        setCargando(true);
        try {
            var pConcurrencia = false;
            var numeropProduccion = 0;
            var pproduccionCF = [];
            var planeacionU = {};
            var PProduccionG = {};
            //Se obtienen los datos de la planeación por número para revisar la concurrencia
            //Se obtienen los datos
            let cfilter = { and: [{ numero: { eq: planeaciones[0].numero, } }, { activo: { eq: true } }] }
            const planeacionesFromAPI = await GetPProduccion(cfilter);
            //Se obtiene el número de plan de producción           
            numeropProduccion = planeaciones[0].numero;
            await Promise.all(planeaciones.map(async planeacion => {
                //Se revisa concurrencia en planeaciones
                const planeacionC = planeacionesFromAPI.filter(cplaneacion => cplaneacion.id === planeacion.id);
                if (planeacionC.length < 1) {//Si no se obtuvieron los datos, se marca como concurrencia
                    pConcurrencia = true;
                } else {//Si se encontraron datos, se comparan las fechas de última actualización para determinar si hay concurrencia.
                    if (planeacion.updatedAt !== planeacionC[0].updatedAt)
                        pConcurrencia = true;
                }
            }));
            //Si el plan de producción es de días anteriores, no se permite la eliminación.
            const pproduccionFA = planeacionesFromAPI.filter(pProduccion => Moment(pProduccion.fechaDePlaneacion).format("YYYY-MM-DD") < Moment(new Date()).format("YYYY-MM-DD"));
            if (pproduccionFA.length > 0) {
                window.scrollTo(0, 0);
                setMensajeAlert("No fue posible realizar la operación: no se permite la eliminación de Planeaciones de días anteriores al actual");
                setColor("warning");
                setCargando(false);
                setAVisible(true);
                fetchPlaneaciones(rfechaini, rfechafin);
                return;
            }
            //Si algún material del plan de producción se encuentra en carga, no se permite la eliminación.
            const pProduccionCP = planeacionesFromAPI.filter(pProduccion => ((pProduccion.piezasenCarga ? pProduccion.piezasenCarga : 0) > 0 || (pProduccion.piezasenPintado ? pProduccion.piezasenPintado : 0) > 0));
            if (pProduccionCP.length > 0) {
                window.scrollTo(0, 0);
                setMensajeAlert("No fue posible realizar la operación: no se permite la eliminación de Planeaciones si ya tienen registro de material cargado o pintado");
                setColor("warning");
                setCargando(false);
                setAVisible(true);
                fetchPlaneaciones(rfechaini, rfechafin);
                return;
            }
            //Si algún material del plan de producción se encuentra en carga, no se permite la eliminación.
            const pProduccionDP = planeacionesFromAPI.filter(pProduccion => ((pProduccion.desdePproduccion ? pProduccion.desdePproduccion : false) === true));
            if (pProduccionDP.length > 0) {
                window.scrollTo(0, 0);
                setMensajeAlert("No fue posible realizar la operación: no se permite la eliminación de Planeaciones si existe al menos un registro de material desde producción");
                setColor("warning");
                setCargando(false);
                setAVisible(true);
                fetchPlaneaciones(rfechaini, rfechafin);
                return;
            }
            //Si no existe concurrencia, se actualizan los datos en RecibaSeriales y se marca activo igual a falso  en planeaciones
            if (pConcurrencia === false) {
                //Se actualizan los datos en reciba seriales y en planeación                
                await Promise.all(planeaciones.map(async (planeacion, i) => {
                    if (planeacion.recibaSerialID) {
                        //Se obtienen los datos del reciba Serial por ID                     
                        const recibaFromAPI = await GetRecibaSerialesID(planeacion.recibaSerialID);
                        //Se actualizan los datos en reciba seriales  
                        if (recibaFromAPI.id) {
                            delete recibaFromAPI.createdAt;
                            delete recibaFromAPI.updatedAt;
                            delete recibaFromAPI.__typename;
                            recibaFromAPI.cantidadPlaneada = (recibaFromAPI.cantidadPlaneada - planeacion.cantidadPiezas) < 0 ? 0 : recibaFromAPI.cantidadPlaneada - planeacion.cantidadPiezas;
                            let rdseriales = await API.graphql({ query: updateRecibaSeriales, variables: { input: recibaFromAPI } });

                            const recibaSerialMPID = recibaFromAPI.recibaSerialMPID;
                            if (recibaFromAPI.recibaSerialMPID) {
                                delete recibaFromAPI.recibaSerialMPID;
                                recibaFromAPI.rsUpdatedAt = rdseriales.data.updateRecibaSeriales.updatedAt;
                                await API.graphql({
                                    query: updateRecibaSerialesMP,
                                    variables: { input: { ...recibaFromAPI, id: recibaSerialMPID } },
                                });
                            }
                        }
                    }
                    //Se actualizan los datos en la planeación
                    delete planeacion.paginacion;
                    delete planeacion.color;
                    delete planeacion.createdAt;
                    delete planeacion.updatedAt;
                    delete planeacion.__typename;
                    delete planeacion.cantidadDisponible;
                    planeacion.Reg_Mod_Usuario = userName;
                    planeacion.activo = false;
                    await API.graphql({ query: updatePProduccion, variables: { input: planeacion } });
                }));
                //Seactualiza el registro general de plan de producción.
                const fpproduccionGeneralID = planeaciones.filter(pproduccion => (pproduccion.pproduccionGeneralID ? pproduccion.pproduccionGeneralID : "") != "");
                if (fpproduccionGeneralID.length > 0) {
                    setMensajeAlert("Problemas al actualizar el plan de producción general 0 ");
                    PProduccionG = await GetPProduccionGeneralID(fpproduccionGeneralID[0].pproduccionGeneralID);
                    setMensajeAlert("Problemas al actualizar el plan de producción general 1 ");
                } else {
                    setMensajeAlert("Problemas al actualizar el plan de producción general 3 " + numeropProduccion);
                    PProduccionG = await GetPProduccionGeneral({ and: [{ numero: { eq: numeropProduccion } }, { activo: { eq: true } }] });
                    setMensajeAlert("Problemas al actualizar el plan de producción general 4 ");
                    if (PProduccionG.length > 0) {
                        setMensajeAlert("Problemas al actualizar el plan de producción general 5 ");
                        PProduccionG = PProduccionG[0];
                        setMensajeAlert("Problemas al actualizar el plan de producción general 6 ");
                    }
                }
                if (PProduccionG.id) {
                    setMensajeAlert("Problemas al actualizar el plan de producción general 7 ");
                    const rPProduccion = { ...PProduccionG, activo: false, Reg_Mod_Usuario: userName };
                    delete rPProduccion.createdAt;
                    delete rPProduccion.updatedAt;
                    delete rPProduccion.__typename;
                    setMensajeAlert("Problemas al actualizar el plan de producción general 2 " + JSON.stringify(rPProduccion));
                    await API.graphql({ query: updatePProduccionGeneral, variables: { input: rPProduccion } });
                }

                window.scrollTo(0, 0);
                setMensajeAlert("Operación exitosa");
                setColor("primary");
                setAVisible(true);
                setCargando(false);
                fetchPlaneaciones(rfechaini, rfechafin);
                toggle1('1');

            } else { //Si  hay concurrencia se tienen que actualizar los datos
                window.scrollTo(0, 0);
                setMensajeAlert("No fue posible realizar la operación: existe concurrencia, se recargaron los datos, favor de " +
                    " volver a intentarlo");
                setColor("warning");
                setCargando(false);
                setAVisible(true);
                fetchPlaneaciones(rfechaini, rfechafin);
            }

        } catch (e) {
            window.scrollTo(0, 0);
            //setMensajeAlert("No fue posible realizar la operación: revise su conexión a internet y vuelva a intentar, si el error persiste, favor de comunicarse a sistemas");
            setColor("warning");
            setAVisible(true);
            setCargando(false);
        }

    };
    async function aceptarRANOFIFO() {
        setModal2(!modal2);
        setAVisible(false);
        setCargando(true);
        try {
            //Se revisa que estén todos los datos
            if (!usuarioAutNoFIFO || !comentariosNoFIFO) {
                window.scrollTo(0, 0);
                setMensajeAlert("Faltan datos, por favor ingresa los motivos para no usar el FIFO y elige a quien autorizará.");
                setColor("warning");
                setCargando(false);
                setAVisible(true);
                return;
            }
            //Si el usuario ingreso los datos requeridos, se procede con las demás validaciones
            var pConcurrencia = false;
            var yaPedido = false;
            //Se obtienen los datos de la reciba por id para revisar la concurrencia            
            const recibaSFromAPI = await GetRecibaSerialesID(rPANOFIFO.recibaSerialID);
            //Se revisa si existe concurrencia
            if (!recibaSFromAPI.id) {
                pConcurrencia = true;
            } else {
                if (rPANOFIFO.updatedAt !== recibaSFromAPI.updatedAt)
                    pConcurrencia = true;
            }
            //Se revisa si ya se registró en la base de datos una petición para no utilizar el FIFO para el contenedor seleccionado         
            yaPedido = recibaSFromAPI.solNoFIFO ? recibaSFromAPI.solNoFIFO : false;
            if (yaPedido === true) {
                window.scrollTo(0, 0);
                setMensajeAlert("No fue posible realizar la operación: Ya se encuentra registrada la solicitud para no usar el FIFO para el material en cuestión.");
                setColor("warning");
                setCargando(false);
                setAVisible(true);
                return;
            }
            //Si no existe concurrencia, se actualizan los datos en RecibaSeriales y se marca que ya se solicitó la autorización solNoFIFO
            if (pConcurrencia === false) {
                //Se marca en Reciba seriales como Solicitada la autorización poniendo solNoFIFO = true
                const datosReciba = recibaSFromAPI;
                delete datosReciba.createdAt;
                delete datosReciba.updatedAt;
                delete datosReciba.__typename;
                datosReciba.solNoFIFO = true;
                datosReciba.solNoFIFOModulo = "Planeación";
                datosReciba.solPNoFIFOMotivos = comentariosNoFIFO;
                datosReciba.Reg_Mod_Usuario = userName;
                setMensajeAlert("Problemas al actualizar los datos de reciba");
                let rdseriales = await API.graphql({ query: updateRecibaSeriales, variables: { input: datosReciba } });

                //Se actualizan los cambios en recibaSerialesMP
                const recibaSerialMPID = datosReciba.recibaSerialMPID;
                if (datosReciba.recibaSerialMPID) {
                    delete datosReciba.recibaSerialMPID;
                    datosReciba.rsUpdatedAt = rdseriales.data.updateRecibaSeriales.updatedAt;
                    await API.graphql({
                        query: updateRecibaSerialesMP,
                        variables: { input: { ...datosReciba, id: recibaSerialMPID } },
                    });
                }

                //Tambien se crea un registro nuevo en la tabla de Autorizaciones
                const datosAutorizacion = {};
                datosAutorizacion.recibaSerialID = datosReciba.id;
                datosAutorizacion.clienteID = datosReciba.clienteID;
                datosAutorizacion.cliente = datosReciba.cliente;
                datosAutorizacion.productoID = datosReciba.productoID;
                datosAutorizacion.numerodeParte = datosReciba.numerodeParte;
                datosAutorizacion.descripcion = datosReciba.descripcion;
                datosAutorizacion.serial = datosReciba.serial;
                datosAutorizacion.serialRecibaBTI = datosReciba.serialRecibaBTI;
                datosAutorizacion.peticionTipo = "Autorizar no aplicar FIFO";
                datosAutorizacion.peticionModulo = "Planeación";
                datosAutorizacion.peticionMotivos = comentariosNoFIFO;
                datosAutorizacion.peticionFecha = Moment(new Date()).format("YYYY-MM-DD");
                datosAutorizacion.peticionHora = Moment(new Date()).format("HH:mm");
                datosAutorizacion.peticionUsuario = usariosNC;
                datosAutorizacion.peticionUAutorizar = usuarioAutNoFIFO;
                datosAutorizacion.activo = true;
                datosAutorizacion.cancelado = false;
                datosAutorizacion.Reg_Ins_Usuario = userName;
                setMensajeAlert("Problemas al guardar la solicitud de la autorización");//+ JSON.stringify(datosAutorizacion)
                await API.graphql({ query: createAutorizaciones, variables: { input: datosAutorizacion } });

                window.scrollTo(0, 0);
                setMensajeAlert("Operación exitosa: se requiere llamar por teléfono a " + usuarioAutNoFIFO + " e informarle que tiene una autorización pendiente");
                setColor("primary");
                setAVisible(true);
                setCargando(false);
                setComentariosNoFIFO("");
                setUsuarioAutNoFIFO("");
                fetchReciba();
                //setInputList([]);
                //toggle1('1');

            } else { //Si  hay concurrencia se tienen que actualizar los datos
                window.scrollTo(0, 0);
                setMensajeAlert("No fue posible realizar la operación: existe concurrencia, se actualizarán los datos de almacén, " +
                    "una vez que se actualicen los datos, se requiere volver a intentarlo.");
                setColor("warning");
                setCargando(false);
                setAVisible(true);
                fetchReciba();
            }

        } catch (e) {
            window.scrollTo(0, 0);
            //setMensajeAlert("No fue posible realizar la operación: revise su conexión a internet y vuelva a intentar, si el error persiste, favor de comunicarse a sistemas");
            setColor("warning");
            setAVisible(true);
            setCargando(false);
        }

    };
    async function autorizarNOFIFO() {
        setModal2(!modal2);
        clicPlaneacion(rPANOFIFO, true)
    };
    async function cancelarRANOFIFO() {
        setModal2(!modal2);
        setAVisible(false);
        setCargando(true);
        try {
            //Se revisa que estén todos los datos
            if (!comentariosNoFIFO) {
                window.scrollTo(0, 0);
                setMensajeAlert("Faltan datos, por favor ingresa los motivos para cancelar la solicitud.");
                setColor("warning");
                setCargando(false);
                setAVisible(true);
                return;
            }
            //Si el usuario ingreso los datos requeridos, se procede con las demás validaciones
            var pConcurrencia = false;
            var yaPedido = false;
            //Se obtienen los datos de la reciba por id para revisar la concurrencia                    
            const recibaSFromAPI = await GetRecibaSerialesID(rPANOFIFO.recibaSerialID);
            //Se revisa si existe concurrencia
            if (!recibaSFromAPI.id) {
                pConcurrencia = true;
            } else {
                if (rPANOFIFO.updatedAt !== recibaSFromAPI.updatedAt)
                    pConcurrencia = true;
            }
            //Se revisa si ya se canceló la solicitud       
            yaPedido = recibaSFromAPI.solNoFIFO ? recibaSFromAPI.solNoFIFO : false;
            if (yaPedido === false) {
                window.scrollTo(0, 0);
                setMensajeAlert("No fue posible realizar la operación: Ya se encuentra cancelada la solicitud para no usar el FIFO para el material en cuestión.");
                setColor("warning");
                setCargando(false);
                setAVisible(true);
                return;
            }
            //Si no existe concurrencia, se actualizan los datos en RecibaSeriales y se marca que ya se canceló la solicitó la autorización solNoFIFO
            if (pConcurrencia === false) {
                //Se marca en Reciba seriales como cancelada la solicitud poniendo solNoFIFO = false
                const datosReciba = recibaSFromAPI;
                delete datosReciba.createdAt;
                delete datosReciba.updatedAt;
                delete datosReciba.__typename;
                datosReciba.solNoFIFO = false;
                datosReciba.Reg_Mod_Usuario = userName;
                setMensajeAlert("Problemas al actualizar los datos de reciba");
                let rdseriales = await API.graphql({ query: updateRecibaSeriales, variables: { input: datosReciba } });

                const recibaSerialMPID = datosReciba.recibaSerialMPID;
                if (datosReciba.recibaSerialMPID) {
                    delete datosReciba.recibaSerialMPID;
                    datosReciba.rsUpdatedAt = rdseriales.data.updateRecibaSeriales.updatedAt;
                    await API.graphql({
                        query: updateRecibaSerialesMP,
                        variables: { input: { ...datosReciba, id: recibaSerialMPID } },
                    });
                }
                //Filtro para obtener autorizaciones.
                let afilter = {
                    and: [{
                        recibaSerialID: {
                            eq: rPANOFIFO.recibaSerialID
                        }
                    },
                    {
                        activo: {
                            eq: true
                        }
                    }
                        ,
                    {
                        cancelado: {
                            eq: false
                        }
                    }
                    ]
                }

                //Tambien se crea un registro nuevo en la tabla de Autorizaciones
                const apiData = await GetAutorizaciones(afilter);
                if (apiData[0]) {
                    const datosAutorizacion = apiData[0];
                    delete datosAutorizacion.createdAt;
                    delete datosAutorizacion.updatedAt;
                    delete datosAutorizacion.__typename;
                    datosAutorizacion.cancelado = true;
                    datosAutorizacion.cancelacionComentarios = comentariosNoFIFO;
                    datosAutorizacion.Reg_Mod_Usuario = userName;
                    setMensajeAlert("Problemas al cancelar la solicitud " + JSON.stringify(datosAutorizacion));//+ JSON.stringify(datosAutorizacion)
                    await API.graphql({ query: updateAutorizaciones, variables: { input: datosAutorizacion } });

                    setMensajeAlert("Operación exitosa: se requiere llamar por teléfono a " + datosAutorizacion.peticionUAutorizar + " e informarle que se canceló la solicitud en cuestión");
                    setColor("primary");

                } else {

                    setMensajeAlert("Operación errónea: No se pudo encontrar el registro relacionado, por favor comunicar el problema al área de sistemas");
                    setColor("warning");
                }
                window.scrollTo(0, 0);
                setAVisible(true);
                setCargando(false);
                setComentariosNoFIFO("");
                setUsuarioAutNoFIFO("");
                fetchReciba();
                //setInputList([]);
                //toggle1('1');

            } else { //Si  hay concurrencia se tienen que actualizar los datos
                window.scrollTo(0, 0);
                setMensajeAlert("No fue posible realizar la operación: existe concurrencia, se actualizarán los datos de almacén, " +
                    "una vez que se actualicen los datos, se requiere volver a intentarlo.");
                setColor("warning");
                setCargando(false);
                setAVisible(true);
                fetchReciba();
            }

        } catch (e) {
            window.scrollTo(0, 0);
            //setMensajeAlert("No fue posible realizar la operación: revise su conexión a internet y vuelva a intentar, si el error persiste, favor de comunicarse a sistemas");
            setColor("warning");
            setAVisible(true);
            setCargando(false);
        }

    };
    function revisarCantidadValida(list) {
        var cantidadValida = true;
        list.map((planeacion, i) => {
            if (planeacion.cantidadDisponible < planeacion.cantidadPiezas || planeacion.cantidadPiezas == 0) {
                cantidadValida = false;
            };
        });
        return cantidadValida;
    }
    function FaltanDatosPlaneacion(list) {
        var fdatos = false;
        list.map((planeacion, i) => {
            if (planeacion.activo) {
                if (!planeacion.productoID || !planeacion.cliente || !planeacion.numerodeParte ||
                    !planeacion.prioridad || !planeacion.cantidadPiezas || !planeacion.racks || !planeacion.ciclos) {
                    fdatos = true;
                };
            };
        });
        setFaltanDatos(fdatos);
        return fdatos;
    };
    async function validacionesPlaneacion(list) {
        var fdatos = false;
        var cantidadValida = true;
        var iDSActivos = []
        list.map((planeacion, i) => {
            //Se revisa si faltan datos
            if (planeacion.activo) {
                if (!planeacion.productoID || !planeacion.cliente || !planeacion.numerodeParte ||
                    !planeacion.prioridad || !planeacion.cantidadPiezas || !planeacion.racks || !planeacion.ciclos) {
                    fdatos = true;
                };
            };
            //Se revisa si hay cantidades no válidas
            if (planeacion.cantidadDisponible < planeacion.cantidadPiezas || planeacion.cantidadPiezas == 0) {
                cantidadValida = false;
            };
            //Se obtienen los ids de los registros activos
            if (planeacion.activo === true && planeacion.id) {
                iDSActivos.push({ id: planeacion.id })
            }
        });
        setFaltanDatos(fdatos);
        const resultado = { faltanDatos: fdatos, valido: cantidadValida, ids: iDSActivos }
        return resultado;
    };
    //Función para crear y guardar cambios de planeaciones
    async function managePlaneacion() {
        setAVisible(false);
        setCargando(true);
        setisDisabled(true);
        const revisarDatos = await validacionesPlaneacion(inputList);
        const cantidadValida = revisarDatos.valido;
        const faltandatosInput = revisarDatos.faltanDatos;
        //Se filtran loa datos del inputList, para obtener los que son nuevos o se modificaron        
        try {
            //Se revisa si faltan datos
            if (faltandatosInput || !fechaPlaneacion || cantidadValida === false) {
                setMensajeAlert("Faltan datos o son erróneos: los campos marcados con un asterisco son obligatorios," +
                    " la cantidad del material agregado desde almacén no pude ser mayor a la cantidad disponible para su planeación," +
                    " la cantidad no puede ser cero." +
                    " Se marcan en rojo las cantidad errónea.");
                setColor("warning");
                setAVisible(true);
                setisDisabled(false);
                setCargando(false);
                window.scrollTo(0, 0);
            } else { //Si no faltan datos
                setMensajeAlert("No faltaron datos");
                var numeroUP = 1;
                var numeroUPP = 0;
                var numeroPlaneacion = numeroP;
                var recibamSeriales = [];
                var problemasplanproduccion = false;
                //Se obtienen las planeaciones de la fecha elegida para validar que no existan mas de una del mismo día  
                var pConcurrencia = false;
                var planeacionf = [];
                var pproduccionGeneralID = "";
                //________________________________________________
                //Se revisa si hay planeaciones con la misma fecha
                if (!editar) {
                    setMensajeAlert("Previo a obtener los datos de la planeación");
                    const apiDataf = await GetPProduccionGeneral({ and: [{ fechaDePlaneacion: { eq: fechaPlaneacion } }, { activo: { eq: true } }] });
                    //const apiDataf = await GetPlaneacionGeneral({ and: [{ fechaDePlaneacion: { eq: fechaPlaneacion } }, { activo: { eq: true } }] });
                    planeacionf = apiDataf;
                    //Se revisa si ya existe una planeación con la fecha elegida, si ya existe una planeación del mismo día, 
                    //no se procede con la operación.
                    setMensajeAlert("Después a obtener los datos de la planeación");
                    if (planeacionf.length > 0) {
                        window.scrollTo(0, 0);
                        setMensajeAlert("No fue posible realizar la operación: Ya existe una Planeación con la fecha elegida, " +
                            "favor de elegir otra fecha y volver a intentarlo");
                        setColor("warning");
                        setCargando(false);
                        setAVisible(true);
                        setisDisabled(false);
                        return;
                    }
                } else {//Si es una actualización de datos.
                    //Se revisa si ya existe una planeación con la fecha elegida diferente al que se está editando.
                    setMensajeAlert("Previo de obtener la planeación 2");
                    const apiDataf = await GetPProduccion({ or: [{ fechaDePlaneacion: { eq: fechaPlaneacion } }, { numero: { eq: numeroP } }] });
                    //const apiDataf = await GetPlaneacion({ or: [{ fechaDePlaneacion: { eq: fechaPlaneacion } }, { numero: { eq: numeroP } }] });
                    planeacionf = await apiDataf.filter(planeacion => planeacion.activo === true);
                    const planeacionfid = planeacionf.filter(planeacionfi => planeacionfi.numero !== numeroPlaneacion);
                    setMensajeAlert("Después de obtener la planeación 2");
                    //Si ya existe una planeación del mismo día, no se procede con la operación. 
                    if (planeacionfid.length > 0) {
                        window.scrollTo(0, 0);
                        setMensajeAlert("No fue posible realizar la operación: Ya existe una Planeación con la fecha elegida, " +
                            "favor de elegir otra fecha y volver a intentarlo ");
                        setColor("warning");
                        setCargando(false);
                        setAVisible(true);
                        setisDisabled(false);
                        return;
                    }
                }
                //___________________________________________________________________
                setMensajeAlert("Antes de revisar concurrencia");
                var InputListM = inputList.filter(planeacionM => !planeacionM.id || (planeacionM.id &&
                    (planeacionM.cantidadPiezas !== planeacionM.cantidadOriginal || planeacionM.prioridad !== planeacionM.prioridadOriginal ||
                        planeacionM.racks !== planeacionM.racksOriginal || planeacionM.materialEnCantidad !== planeacionM.materialEnCantidadOriginal ||
                        planeacionM.ciclos !== planeacionM.ciclosOriginal || planeacionM.activo === false || planeacionM.fechaDePlaneacion !== fechaPlaneacion)));
                var recibaDatosAc = {}
                //Se obtienen los datos de recibaSeriales y se revisa la concurrencia 
                await Promise.all(InputListM.map(async (planeacion, i) => {
                    setMensajeAlert("Revisando concurrencia, i: " + i + " planeación:" + JSON.stringify(planeacion));
                    //Se obtienen los datos del recibaSerial

                    if (planeacion.recibaSerialID) {
                        //Se obtiene el registro actualizado de los reciba seriales 
                        setMensajeAlert("Intentando obtener datos 1: " + i + " serial" + JSON.stringify(recibamSeriales));
                        //Se agregan los datos obtenidos
                        const rSeriales = await GetRecibaSerialesID(planeacion.recibaSerialID);
                        recibamSeriales.push(rSeriales);
                        recibaDatosAc = await rSeriales;
                        setMensajeAlert("Datos obtenidos. Revisando problemas PP 2, i: " + i + " serial" + JSON.stringify(rSeriales));
                    }
                    setMensajeAlert("Datos obtenidos. Revisando problemas PP 2, i: " + i + " serial" + JSON.stringify(recibamSeriales));
                    //Si existe id, se revisa la concurrencia en planeación                   
                    if (planeacion.id) {
                        //Se revisa si hay concurrencia en la planeación que se está editando.
                        //Se filtran los datos recien obtenidos por el número de planeación por el id de la planeación.
                        const planeacionesC = planeacionf.filter(planeacionfi => planeacionfi.id === planeacion.id);
                        //Se filtran los datos de planeaciones sin filtro por el número de planeación que se está editando.
                        if (planeacionesC.length < 1) {//Si no se obtuvieron los datos, se marca como concurrenci
                            pConcurrencia = true;
                            setMensajeAlert("Concurrencia en planeación 1");
                        } else {//Si se encuentra el dato, se revisa si hay concurrencia comparando el campo updatedAt de los datos obtenidos
                            if (planeacion.updatedAt !== planeacionesC[0].updatedAt) {
                                pConcurrencia = true;
                                setMensajeAlert("Concurrencia en planeación 2");
                            }
                        }
                        //Se revisan problemas en plan de producción.
                        setMensajeAlert("Datos obtenidos. Revisando problemas PP 1: i:" + i + " Planeación:" + JSON.stringify(planeacion));
                        if (planeacion.recibaSerialID) {
                            if (editar && recibaDatosAc) {
                                if ((planeacion.cantidadPiezas !== recibaDatosAc.cantidadPlaneada || fechaPlaneacion !== planeacion.fechaDePlaneacion ||
                                    planeacion.activo === false) && (planeacion.terminado === true ||
                                        planeacion.fechaDePlaneacion < Moment(now2).format("YYYY-MM-DD")))
                                    problemasplanproduccion = true;
                            }
                        }
                        setMensajeAlert("Datos obtenidos. Revisando problemas PP 3 " + i + " Planeación:" + JSON.stringify(planeacion));
                    }
                    //setMensajeAlert("Antes de revisar la concurrencia para los seriales en almacén");
                    //Si hay datos modificados relacionados a la cantidad, se obtienen los datos para revisar concurrencia.
                    //Y para más adelante hacer la modificación en reciba
                    if (planeacion.recibaSerialID && (planeacion.cantidadOriginal === 0 || planeacion.activo === false ||
                        planeacion.cantidadPiezas !== planeacion.cantidadOriginal)) {
                        //setMensajeAlert("Revisando la concurrencia para los seriales en almacén: " + JSON.stringify(planeacion));                        
                        //Se revisa la concurrencia
                        if (!recibaDatosAc.id) { //Si no se obtuvieron los datos, se marca como concurrencia
                            pConcurrencia = true;
                            setMensajeAlert("No fue posible realizar la operación: existe concurrencia en reciba (1). Se recargaron los datos,  favor de  " +
                                " volver a intentarlo");
                        } else { //Si se encontraron datos
                            setMensajeAlert("Datos encontrados: " + JSON.stringify(recibamSeriales));
                            //Se filtra recibaSinFiltro para obtener el dato de reciba con el que se está trabajando
                            const recibaDatos = recibaSinFiltro.filter(recibad => recibad.id === planeacion.recibaSerialMPID)
                            if (recibaDatos.length < 1) { //Si no encuentra el dato, se marca como concurrencia
                                pConcurrencia = true;
                                setMensajeAlert("No fue posible realizar la operación: existe concurrencia en reciba (2). Se recargaron los datos,  favor de  " +
                                    " volver a intentarlo");
                            } else { //Si se encuentra el dato, se revisa si hay concurrencia comparando el campo updatedAt de los datos obtenidos
                                if (recibaDatosAc.updatedAt !== recibaDatos[0].rsUpdatedAt) {
                                    pConcurrencia = true;
                                    setMensajeAlert("No fue posible realizar la operación: existe concurrencia en reciba (3). Se recargaron los datos,  favor de  " +
                                        " volver a intentarlo. recibaDatosAc.updatedAt: ");
                                }
                            }
                        }
                    }
                    //Si se detectaron problemas, se termina el proceso de revisión.
                    if (pConcurrencia === true || problemasplanproduccion === true) {
                        return;
                    }
                }));
                //Si el material ya se en cuentra en producción y es el día de 
                if (problemasplanproduccion === true) {
                    window.scrollTo(0, 0);
                    setMensajeAlert("No fue posible realizar la operación: uno o más registros que se intentan modificar, " +
                        "ya se han empezado a trabajar en producción o fueron transferidos a otro día.");
                    setColor("warning");
                    setCargando(false);
                    setAVisible(true);
                    setisDisabled(false);
                    return;
                }
                //Si no se detectó concurencia,se procede con la operación.
                if (pConcurrencia === false) {
                    setMensajeAlert("Antes de insertar");
                    //Si no es editar, se intenta crear un nuevo número de planeación
                    if (!editar) {//Si es una inserción.                        
                        setMensajeAlert("Previo de obtener el último número");
                        //Si no existe otra planeación del mismo día, se procede a crear el nuevo número de la planeación en la tabla PlaneacionUltimoNumero
                        //Primero se obtienen los registro de la tabla PlaneacionUltimoNumeros                   
                        const apiData = await API.graphql({ query: listPProduccionUltimoNumeros, variables: { limit: 100000000 } });
                        const ultimapFromAPI = apiData.data.listPProduccionUltimoNumeros.items;
                        setMensajeAlert("Después de obtener el último número");
                        //Si se obtuvieron registros, se aumenta en 1 el campo "numero" que indica el número de la nueva planeación.
                        await Promise.all(ultimapFromAPI.map(async ultimaplaneacion => {
                            numeroUP = ultimaplaneacion.numero + 1;
                            ultimaplaneacion.numero = numeroUP;
                            delete ultimaplaneacion.createdAt;
                            delete ultimaplaneacion.updatedAt;
                            delete ultimaplaneacion.__typename;
                            //ultimaplaneacion.fechaDePlaneacion = fechaPlaneacion;
                            //ultimaplaneacion.horasProduccion = sumProduccionp;
                            ultimaplaneacion.Reg_Mod_Usuario = userName;
                            await API.graphql({ query: updatePProduccionUltimoNumero, variables: { input: ultimaplaneacion } })
                            return ultimaplaneacion;
                        }))
                        setMensajeAlert("Previo a crear el último número");
                        //Si no se obtuvieron registros, se crea un nuevo registro con el número de la planeación.
                        if (!ultimapFromAPI.length) {
                            await API.graphql({
                                query: createPProduccionUltimoNumero, variables: {
                                    input: {
                                        numero: numeroUP,
                                        activo: true,
                                        Reg_Ins_Usuario: userName
                                    }
                                }
                            });
                        }
                        numeroPlaneacion = numeroUP;
                        setMensajeAlert("Después el último número");
                        //Se crea el registro de la planeación general
                        setMensajeAlert("Problemas al guardar la planeación general 1");
                        let resulpg = await API.graphql({
                            query: createPProduccionGeneral, variables: {
                                input: {
                                    fechaDePlaneacion: fechaPlaneacion,
                                    numero: numeroUP,
                                    espacioVacio: 0,
                                    activo: true,
                                    Reg_Ins_Usuario: userName
                                }
                            }
                        });
                        pproduccionGeneralID = resulpg.data.createPProduccionGeneral.id;
                    } else {//Si es una edición.
                        //Se revisa si uno de los registros que se está editango tiene el 
                        const regPlaneaciong = inputList.filter(planeacion => (planeacion.pproduccionGeneralID ? planeacion.pproduccionGeneralID : "") != "");
                        if (regPlaneaciong.length > 0) {
                            pproduccionGeneralID = regPlaneaciong[0].pproduccionGeneralID;
                        } else {
                            //Se revisa si ya hay una planeación de la fecha y el número de planeación en cuestión
                            const planGeneral = await GetPProduccionGeneral({ and: [{ fechaDePlaneacion: { eq: fechaPlaneacion } }, { numero: { eq: numeroUP } }, { activo: { eq: true } }] });
                            if (planGeneral.length > 0) {
                                pproduccionGeneralID = planGeneral[0].id;

                            } else {
                                //Se crea el registro de la planeación general
                                setMensajeAlert("Problemas al guardar la planeación general 1");
                                let resulpg = await API.graphql({
                                    query: createPProduccionGeneral, variables: {
                                        input: {
                                            fechaDePlaneacion: fechaPlaneacion,
                                            numero: numeroUP,
                                            espacioVacio: 0,
                                            activo: true,
                                            Reg_Ins_Usuario: userName
                                        }
                                    }
                                });
                                pproduccionGeneralID = resulpg.data.createPProduccionGeneral.id;
                            }

                        }
                    }
                    //Se declaran variables auxiliares para obtener los ids de planeación y plan de producción.
                    var planeacionIDS = revisarDatos.ids;
                    var pproduccionIDS = [];
                    var pproduccionIDSC = [];
                    var rSerialesIDS = [];
                    var rSerialesIDSC = [];
                    var mensaje = "";
                    //Si no existe concurrencia, se continúa con el proceso
                    await Promise.all(InputListM.map(async (planeacion, i) => {
                        /*if (mensaje != "") {
                            setMensajeAlert(mensaje);
                            return
                        }*/
                        //Actualiza la cantidad en reciba seriales si hay datos modificados para el reciba serial en cuestión                      
                        const recibam = recibamSeriales.filter(recibas => recibas.id === planeacion.recibaSerialID);
                        //Se actualizan los datos en reciba seriales
                        await Promise.all(recibam.map(async reciba => {
                            delete reciba.updatedAt;
                            delete reciba.__typename;
                            delete reciba.createdAt;
                            reciba.Reg_Mod_Usuario = userName;

                            if (planeacion.autNoFIFO !== null && planeacion.autNoFIFO !== reciba.autNoFIFO)
                                reciba.autNoFIFO = planeacion.autNoFIFO

                            if (planeacion.autPNoFIFOComentTIOA !== null && planeacion.autPNoFIFOComentTIOA !== reciba.autPNoFIFOComentTIOA)
                                reciba.autPNoFIFOComentTIOA = planeacion.autPNoFIFOComentTIOA

                            reciba.cantidadPlaneada = planeacion.cantidadOriginal === 0 ? parseInt(planeacion.cantidadPlaneadaOriginal) + parseInt(planeacion.cantidadPiezas) :
                                planeacion.activo === false ? parseInt(reciba.cantidadPlaneada) - parseInt(planeacion.cantidadOriginal) :
                                    planeacion.cantidadPiezas === planeacion.cantidadOriginal ? reciba.cantidadPlaneada :
                                        planeacion.cantidadPiezas > planeacion.cantidadOriginal ?
                                            parseInt(reciba.cantidadPlaneada) + parseInt(planeacion.cantidadPiezas - planeacion.cantidadOriginal) :
                                            parseInt(reciba.cantidadPlaneada) - parseInt(planeacion.cantidadOriginal - planeacion.cantidadPiezas);
                            setMensajeAlert("Problemas al actualizar los datos en RecibaSeriales " + JSON.stringify(reciba));
                            let rdseriales = await API.graphql({ query: updateRecibaSeriales, variables: { input: reciba } });

                            const recibaSerialMPID = reciba.recibaSerialMPID;
                            if (reciba.recibaSerialMPID) {
                                delete reciba.recibaSerialMPID;
                                reciba.rsUpdatedAt = rdseriales.data.updateRecibaSeriales.updatedAt;
                                await API.graphql({
                                    query: updateRecibaSerialesMP,
                                    variables: { input: { ...reciba, id: recibaSerialMPID } },
                                });
                            }
                        }));
                        //Se eliminan datos auxiliares
                        delete planeacion.autNoFIFO
                        delete planeacion.autPNoFIFOComentTIOA
                        delete planeacion.cantidadPlaneadaOriginal;
                        delete planeacion.cantidadDisponible;
                        delete planeacion.cantidadOriginal;
                        delete planeacion.prioridadOriginal;
                        delete planeacion.racksOriginal;
                        delete planeacion.materialEnCantidadOriginal;
                        delete planeacion.ciclosOriginal;
                        delete planeacion.updatedAt;
                        delete planeacion.__typename;

                        //Se determina el orden del registro
                        if (planeacion.activo) {
                            planeacion.orden = i + 1;
                        }
                        //Si es una planeación nueva se crea el registro en planeación
                        if (!editar) {
                            planeacion.pproduccionGeneralID = pproduccionGeneralID;
                            planeacion.fechaDePlaneacion = fechaPlaneacion;
                            planeacion.Reg_Ins_Usuario = userName;
                            planeacion.numero = numeroUP;
                            planeacion.desdeAlmacen = false;
                            planeacion.fechaHoraCreacion = Moment(new Date()).format("YYYY-MM-DD HH:mm");
                            planeacion.desdePproduccion = false;
                            //Datos del plan de producción                           
                            setMensajeAlert("Problemas al crear el registro en planeación " + JSON.stringify(planeacion));
                            mensaje = "Problemas al crear el registro en planeación " + JSON.stringify(planeacion);
                            let resultPP = await API.graphql({ query: createPProduccion, variables: { input: planeacion } });
                            pproduccionIDS.push({ id: resultPP.data.createPProduccion.id, nuevo: true, activo: true });
                            pproduccionIDSC.push({ id: resultPP.data.createPProduccion.id });
                            rSerialesIDS.push({ id: resultPP.data.createPProduccion.recibaSerialID, nuevo: true, activo: true });
                            rSerialesIDSC.push({ id: resultPP.data.createPProduccion.recibaSerialID });
                            mensaje = "";
                        } else {
                            planeacion.fechaDePlaneacion = fechaPlaneacion;
                            if (planeacion.id) {
                                delete planeacion.createdAt;
                                delete planeacion.updatedAt;
                                delete planeacion.__typename;
                                delete planeacion.cantidadDisponible;
                                delete planeacion.paginacion;
                                delete planeacion.color;
                                //Datos del plan de producción                                
                                planeacion.Reg_Mod_Usuario = userName;
                                setMensajeAlert("Problemas al actualizar el registro en planeación " + JSON.stringify(planeacion));
                                mensaje = "Problemas al actualizar el registro en planeación " + JSON.stringify(planeacion);
                                let resultPP = await API.graphql({ query: updatePProduccion, variables: { input: planeacion } });
                                if (resultPP.data.updatePProduccion.activo === false) {
                                    pproduccionIDS.push({ id: resultPP.data.updatePProduccion.id, nuevo: false, activo: false });
                                    rSerialesIDS.push({ id: resultPP.data.updatePProduccion.recibaSerialID, nuevo: false, activo: false });
                                }
                                mensaje = "";
                            } else {
                                //Si es una modificación y es un nuevo registro, se pone la variable nuevo igual a true.                                
                                planeacion.pproduccionGeneralID = pproduccionGeneralID;
                                planeacion.desdeAlmacen = false;
                                planeacion.fechaHoraCreacion = Moment(new Date()).format("YYYY-MM-DD HH:mm");
                                planeacion.desdePproduccion = false;
                                planeacion.Reg_Ins_Usuario = userName;
                                planeacion.numero = numeroP;
                                mensaje = "Problemas al crear el registro en planeación " + JSON.stringify(planeacion);
                                setMensajeAlert("Problemas al crear el registro en planeación " + JSON.stringify(planeacion));
                                let resultPP = await API.graphql({ query: createPProduccion, variables: { input: planeacion } });
                                pproduccionIDS.push({ id: resultPP.data.createPProduccion.id, nuevo: true, activo: true });
                                pproduccionIDSC.push({ id: resultPP.data.createPProduccion.id });
                                rSerialesIDS.push({ id: resultPP.data.createPProduccion.recibaSerialID, nuevo: true, activo: true });
                                rSerialesIDSC.push({ id: resultPP.data.createPProduccion.recibaSerialID });
                                mensaje = "";
                            }
                            numeroPlaneacion = planeacion.numero;
                        }
                        /***************************************************************************************************/
                        return planeacion;
                    }));
                    //Seactualiza el registro general de plan de producción.
                    const PProduccionG = await GetPProduccionGeneralID(pproduccionGeneralID);
                    if (PProduccionG.id) {
                        setMensajeAlert("Problemas al actualizar el plan de producción general 3: PProducción General " + JSON.stringify(PProduccionG) +
                            "PProducción ids" + JSON.stringify(pproduccionIDS));

                        const datosPPINDS = PProduccionG.PProduccionIDS ? PProduccionG.PProduccionIDS.length > 0 ?
                            await combinarIDS(PProduccionG.PProduccionIDS, pproduccionIDS) : pproduccionIDSC : pproduccionIDSC;

                        const rsgids = PProduccionG.recibaSerialIDS ? PProduccionG.recibaSerialIDS.length > 0 ? PProduccionG.recibaSerialIDS : [] : [];
                        const datosRSerialIDS = await combinarIDS(rsgids, rSerialesIDS);
                        setMensajeAlert("Problemas al actualizar el plan de producción general 4 " + JSON.stringify(datosPPINDS));
                        const rPProduccion = {
                            ...PProduccionG,
                            PProduccionIDS: datosPPINDS,
                            recibaSerialIDS: datosRSerialIDS,
                            activo: datosPPINDS.length > 0 ? true : false,
                            Reg_Mod_Usuario: userName
                        };
                        delete rPProduccion.createdAt;
                        delete rPProduccion.updatedAt;
                        delete rPProduccion.__typename;
                        setMensajeAlert("Problemas al actualizar el plan de producción general 2 " + JSON.stringify(rPProduccion));
                        await API.graphql({ query: updatePProduccionGeneral, variables: { input: rPProduccion } });
                    }

                    setMensajeAlert("Operación exitosa. ");
                    setisDisabled(false);
                    setColor("primary");
                    setAVisible(true);
                    setCargando(true);
                    fetchPlaneaciones(rfechaini, rfechafin);
                    setEditar(false);
                    toggle1('1');
                    setFechaPlaneacion("");
                    setCargando(false);
                } else {
                    window.scrollTo(0, 0);
                    /*setMensajeAlert("No fue posible realizar la operación: existe concurrencia. Se recargaron los datos,  favor de  " +
                        " volver a intentarlo");*/
                    setColor("warning");
                    setCargando(false);
                    setAVisible(true);
                    setisDisabled(false);
                    fetchPlaneaciones(rfechaini, rfechafin);
                }
            }
        } catch (e) {
            window.scrollTo(0, 0);
            //setMensajeAlert(JSON.stringify(e.message));
            setColor("warning");
            setAVisible(true);
            setCargando(false);
            setisDisabled(false);
        }
    };
    //Revisa cambios en la fecha de búsqueda
    function onChangesRFechaP(e) {
        e.persist()
        var fechaini = rfechaini;
        var fechafin = rfechafin;
        if (e.target.name === "Irfechaini") {
            fechaini = e.target.value;
        } else {
            fechafin = e.target.value;
        }
        setRfechafin(fechafin);
        setRfechaini(fechaini);
        fetchPlaneaciones(fechaini, fechafin);
    }
    //Vista por número de parte
    function onChangescheckVNP(e) {
        window.scrollTo(0, 0);
        setCargando(true);
        setVistaNumeroParte(e.target.checked);
        busquedaPlaneacion(planeacionSinFiltro, currentPagePlaneacion, fechaPBusqueda, e.target.checked);
    }
    //Indicador de vista del más actual al más antigüo en almacén
    function onChangescheckVUAP(e) {
        setVistaUltimoAP(e.target.checked);
        busqueda(recibaSinFiltro, estadoReciba, searchBy, search, currentPage, e.target.checked);
    }
    return {
        verpplaneacion,
        pplaneacion,
        vpreciounitario,
        formType,
        color,
        aVisible,
        mensajeAlert,
        cargando,
        cargando1,
        activeTab,
        rfechafin,
        editar,
        planeaciones,
        fechaPlaneacionM,
        buscarporFecha,
        rfechaini,
        fechaPBusqueda,
        sumProduccion,
        sumICiclos,
        sumCostoTotal,
        modal,
        currentPagePlaneacion,
        paginas, pageRange,
        ultimoNumeroP,
        searchBy,
        search,
        reciba,
        currentPage,
        recordPerPage,
        totalRecords,
        modal2,
        rPANOFIFO,
        planeacionSinFIFO,
        noFIFOUsuarios,
        fechaPlaneacion,
        inputList,
        clientes,
        productosSinFiltro,
        sumProduccionp,
        sumCiclos,
        isDisabled,
        componentRef,
        vistaNumeroParte,
        textPQR,
        precioUnitarioImp,
        planeacionSinFiltro,
        recibaSinFiltro,
        handleScan,
        handleError,
        clicConQR,
        clicBuscarporFecha,
        onSearchFechaPlaneacion,
        toggle1,
        onDismiss,
        cancelarplaneacion,
        managePlaneacion,
        onChangesRFechaP,
        onChangescheckVNP,
        fetchPlaneaciones,
        fetchReciba,
        toggle,
        aceptarEliminar,
        handlePageChangePlaneacion,
        buscarpor,
        setSearch,
        onSearchFecha,
        onSearch,
        onChangescheckVUAP,
        obtenerUltimaUbicaciont,
        clicPlaneacion,
        toggle2,
        cancelarRANOFIFO,
        setComentariosNoFIFO,
        setUsuarioAutNoFIFO,
        setPrecioUnitarioIMP,
        handlePageChange,
        handleRemoveClick,
        aceptarRANOFIFO,
        autorizarNOFIFO,
        setFechaPlaneacion,
        handleAddClick,
        onChangeCliente,
        handleInputChange,
        onChangeProducto,
        setInputList,
        clicEliminar,
        clicEditar,
        handlePrint,
        clicNuevaPlaneacion,
    }
}